// Lista con la que buscan artículos las pantallas de VENTA (NV, presupuestos,
// propuestas, NV móvil). Sugerencia #104 (21 oct 2026): sin lista definida
// (NV antes de elegir cliente, presupuesto sin lista) el buscador traía el
// maestro entero — 72 KIT sin precio en ninguna lista, ENV0004 que rebotó en
// Presea. Sin lista se busca en LISTA1, la de la tienda y el mostrador.
// Un artículo fuera de la lista se carga a propósito desde el buscador grande
// (F2), tildando «Incluir artículos fuera de la lista».
export const LISTA_POR_DEFECTO = 'LISTA1'

export function listaParaBuscar(lista) {
  return lista || LISTA_POR_DEFECTO
}
